import { Box, Divider, Link, Typography } from '@mui/material';

const Footer = ({ isElectricPage, isMobile }) => {
    return (
        <Box
            sx={{
                backgroundColor: '#f2f9fc',
                width: '100%',
                py: 3,
                marginTop: 'auto'
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    width:
                        isElectricPage && !isMobile
                            ? 'calc(100% - 253px)'
                            : 'calc(100% - 3px)',
                    alignItems: 'stretch',
                    ml: isElectricPage && !isMobile ? '253px' : '3px',
                    pl: 2,
                    pr: 2,
                    boxSizing: 'border-box'
                }}
            >
                <Box sx={{ flex: 1, minWidth: 0 }} />
                <Box sx={{ width: '100%', maxWidth: 900, minWidth: 0 }}>
                    <Divider sx={{ marginBottom: '16px', borderColor: '#e0e0e0' }} />
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            alignItems: 'center',
                            justifyContent: isMobile ? 'center' : 'space-between',
                            gap: isMobile ? '12px' : '16px',
                            width: '100%'
                        }}
                    >
                        {!isMobile && (
                            <Typography
                                sx={{
                                    fontSize: '12px',
                                    color: '#666',
                                    whiteSpace: 'nowrap',
                                    flexShrink: 0
                                }}
                            >
                                ©2026 ShirokumaPower Co., Ltd. All rights reserved.
                            </Typography>
                        )}
                        <Box
                            sx={{
                                fontWeight: 'bold',
                                display: 'flex',
                                gap: isMobile ? '12px' : '16px',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                justifyContent: isMobile ? 'center' : 'flex-end'
                            }}
                        >
                            <Link
                                href="https://corp.shirokumapower.com/privacy"
                                target="_blank"
                                underline="hover"
                                sx={{
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    color: '#666',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        textDecoration: 'underline'
                                    }
                                }}
                            >
                                プライバシーポリシー
                            </Link>
                            <Link
                                href="https://shirokumapower.com/tokusyou"
                                target="_blank"
                                underline="hover"
                                sx={{
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    color: '#666',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        textDecoration: 'underline'
                                    }
                                }}
                            >
                                特定商取引法に基づく表記
                            </Link>
                        </Box>
                        {isMobile && (
                            <Typography
                                sx={{
                                    fontWeight: 'bold',
                                    fontSize: '0.6875rem',
                                    color: '#666',
                                    textAlign: 'center'
                                }}
                            >
                                ©2026 ShirokumaPower Co., Ltd. All rights reserved.
                            </Typography>
                        )}
                    </Box>
                </Box>
                <Box sx={{ flex: 2, minWidth: 0 }} />
            </Box>
        </Box>
    );
};

export default Footer;
